import React from 'react';
import {
    Grid,
    Card,
    CardContent,
} from '@mui/material';
import { gridSpacing } from '../../../common/themes/constants';
import ReviewCardGroup from '../../clinics/Management/EnrollClinic/ReviewInformation';

export default function DocumentDetails({data}) {
    return (
        <Card>
            <CardContent>
                <Grid container
                      direction="column"
                      spacing={gridSpacing}>
                    <ReviewCardGroup title="Document Details" data={data} />
                </Grid>
            </CardContent>
        </Card>
    );
}
